import lazySizes from "lazysizes";

//search in header
var modelInitializer = new ModelInitializer();
var url = modelInitializer.Get("SearchLink");

///masterViewModel
if (masterViewModel) {
  masterViewModel.booking = new Booking({});
}

// truncate text than parent height

window.getFlightMinimumPrice = function (items) {
  var data = {
    BasedOnProviders: true,
    FlightCalendarRequests: items,
  };

  $.ajax({
    type: "POST",
    url: "/flight/FlightMinimumPriceCalendar",
    data: data,
    success: function (response) {
      if (response.model && response.model.length) {
        response.model.forEach(function (item) {
          if (item.minimumPrice) {
            $(".js-price-" + CreateFlightMinimumPriceKey(item)).html(
              formatPrice(item.minimumPrice.totalPrice)
            );

            $(".js-currency-" + CreateFlightMinimumPriceKey(item)).html(
              item.minimumPrice.currencyTitle
            );

            $(".js-link-" + CreateFlightMinimumPriceKey(item)).attr(
              "href",
              generateFlightLink(item)
            );

            document
              .querySelectorAll(
                ".js-airline-" + CreateFlightMinimumPriceKey(item)
              )
              .forEach(function (element) {
                element.style.backgroundImage =
                  "url('" +
                  element.getAttribute("airline-logo") +
                  item.minimumPrice.airlineCode +
                  ".png?w=44&h=44" +
                  "')";
                element.setAttribute(
                  "data-bc",
                  "url('" +
                  element.getAttribute("airline-logo") +
                  item.minimumPrice.airlineCode +
                  ".png?w=44&h=44" +
                  "')"
                );
              });

            $(".js-departure-date-" + CreateFlightMinimumPriceKey(item)).html(
              moment(item.minimumPrice.departureDate).format("jDD jMMMM")
            );

            if (
              item.minimumPrice.returnDate &&
              $(".js-return-date-" + CreateFlightMinimumPriceKey(item))
            ) {
              $(".js-return-date-" + CreateFlightMinimumPriceKey(item)).html(
                moment(item.minimumPrice.returnDate).format("jDD jMMMM")
              );
            }
          }
        });
      }
    },
  });
}

window.generateFlightLink = function (route) {
  var url = "/flight/";

  if (route.searchType === 1) {
    url += "int/";
  } else {
    url += "dom/";
  }

  url +=
    route.originCode +
    "-" +
    route.destinationCode +
    "/?adt=1&dep=" +
    moment(route.minimumPrice.departureDate).format("YYYY-MM-DD");

  if (route.minimumPrice.returnDate) {
    url +=
      "&Ret=" + moment(route.minimumPrice.departureDate).format("YYYY-MM-DD");
  }

  return url.toLowerCase();
}

window.CreateFlightMinimumPriceKey = function (route) {
  var flightMinimumPriceKey =
    route.originCode +
    route.destinationCode +
    route.searchType +
    route.beforeDays +
    route.afterDays +
    moment(route.departureDate).format("YYYYMMDD");

  if (route.returnDate) {
    flightMinimumPriceKey += moment(route.returnDate).format("YYYYMMDD");
  }

  return flightMinimumPriceKey.toLowerCase();
}

// init rating
window.initRating = function () {
  // rating
  document.querySelectorAll(".js-rating-demo").forEach(function (item) {
    if (!item.classList.contains("is-init")) {
      var para = document.createElement("div");

      para.classList.add("rating__container");

      var rank = Number(item.getAttribute("data"));
      var icons;
      var halfStar;
      var i;

      for (i = 0; i < 5; i++) {
        var paraIcon = document.createElement("i");
        paraIcon.classList.add("icon-star");

        para.appendChild(paraIcon);
      }

      icons = para.querySelectorAll("i");

      for (i = 0; i < Math.floor(rank); i++) {
        icons[i].classList = "";
        icons[i].classList.add("icon-star", "text-yellow");
      }

      halfStar = i++;

      if (rank % 1 > 0) {
        icons[halfStar].classList = "";
        icons[halfStar].classList.add("icon-half-star", "text-yellow");
      }

      item.classList.add("is-init");

      item.parentElement.appendChild(para);
    }
  });
}

window.formatPrice = function (price) {
  if (price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return 0;
  }
}

// searches functions
window.GoToSearchPage = function (term, baseSearchLink) {
  term = term
    .replace("<", "")
    .replace(">", "")
    .replace("*", "")
    .replace("%", "")
    .replace("&", "")
    .replace(":", "")
    .replace("\\", "")
    .replace("?", "")
    .replace("+", "");
  if (term) $(location).attr("href", baseSearchLink + term);
}

window.GoToSearchTopic = function (term, baseSearchLink) {
  term = term
    .replace("<", "")
    .replace(">", "")
    .replace("*", "")
    .replace("%", "")
    .replace("&", "")
    .replace(":", "")
    .replace("\\", "")
    .replace("?", "")
    .replace("+", "");
  if (term) $(location).attr("href", baseSearchLink + term + "/category-topic");
}

window.popupQuickLoginRegisterV2 = function () {
  $("#signUpModal").eavarModal();

  return false;
}

function validateEmail(email) {
  var emailReg = /^([\w-\.]+@@([\w-]+\.)+[\w-]{2,6})?$/;
  return emailReg.test(email);
}

// get company credit
function getCompanyCredit() {
  $(".js-header-company-credit-refresh").attr("disabled", true);

  $.ajax({
    url: "/fa/userprofile/getcredit/",
    type: "Get",
  })
    .done(function (response) {
      if (response.model) {
        var formattedPrice =
          formatPrice(response.model.price) +
          " " +
          response.model.currencyTitle;

        $(".js-header-company-credit").html(formattedPrice);
      }

      $(".js-header-company-credit-refresh").attr("disabled", false);
    })
    .fail(function (error) {
      if (error.response.isSucceed) {
        showAlert(error.response.messages);
      }

      $(".js-header-company-credit-refresh").attr("disabled", false);
    });
}

$(function () {
  // init lazy load library
  lazySizes.init();

  var screenWidth = screen.width;

  $(document).on("keyup", ".js-input-search", function (e) {
    if (e.keyCode === 13) {
      var term = $(this).val();

      if (term) GoToSearchPage(term, url);
    }
  });

  //toggle menu
  $(".js-navbar-toggler").click(function () {
    var $this = $(this);

    if ($this.hasClass("open")) {
      $("html").removeClass("no-scroll");
      $("body").removeClass("open-modal");
    } else {
      $("html").addClass("no-scroll");
      $("body").addClass("open-modal");
    }

    if ($(".js-account-sub-menu").hasClass("open")) {
      $(".js-account-sub-menu").removeClass("open");
      $(".js-account-sub-menu")
        .next()
        .fadeOut();
    }

    if ($(".js-header").hasClass("search-fade-in")) {
      $(".js-search-btn").click();
    }

    $this.toggleClass("open");
    $this.closest(".js-nav-bar").toggleClass("open-nav");
  });

  //toggle sub menu in MOBILE
  $(".js-menu-toggler").click(function () {
    if ($(this).next().length) {
      if (
        !$(this)
          .next()
          .is(":visible")
      ) {
        $(".js-menu-toggler")
          .next()
          .slideUp();
      }

      $(this)
        .next()
        .slideToggle();
      $(this).toggleClass("open");
    }
  });

  //open search box
  $(".js-search-btn").on("click", function () {
    if ($(".js-navbar-toggler").hasClass("open")) {
      $(".js-navbar-toggler").click();
    }

    if ($(".js-header").hasClass("search-fade-in")) {
      $(".js-header")
        .removeClass("search-fade-in")
        .addClass("search-fade-out");

      $("body").removeClass("open-modal");
    } else {
      $(".js-header")
        .addClass("search-fade-in")
        .removeClass("search-fade-out");

      if (screenWidth > 992)
        $(this)
          .next()
          .offset({
            left: $(this).offset().left,
          });

      $("body").addClass("open-modal");
    }

    setTimeout(function () {
      $(".search-fade-in input[type='text']").trigger("focus");
    }, 400);
  });

  //close search box
  $("body").on("click", function (event) {
    if (
      !$(event.target).closest(".js-header").length &&
      $(".js-header").hasClass("search-fade-in")
    ) {
      $(".js-header")
        .removeClass("search-fade-in")
        .addClass("search-fade-out");

      $("body").removeClass("open-modal");
    }
  });

  //open submenu
  if (screenWidth < 992) {
    $("body").on("click", ".js-menu-with-sub-menu", function (e) {
      e.stopPropagation();
      if ($(e.target).is("i")) {
        e.preventDefault();
        $(e.target)
          .closest("li")
          .toggleClass("open-sub-menu");
      } else {
        $(this).toggleClass("open-sub-menu");
      }
    });
  }

  if (screenWidth < 992) {
    $(".js-account-sub-menu").on("click", function () {
      if (
        $(this)
          .next()
          .is(":visible")
      ) {
        $(this).removeClass("open");
        $(this)
          .next()
          .hide();
        $("body").removeClass("open-modal");
        $("html").removeClass("no-scroll");
      } else {
        $(this)
          .next()
          .show();
        $(this).addClass("open");
        $("body").addClass("open-modal");
        $("html").addClass("no-scroll");
      }

      if ($(".js-nav-bar").hasClass("open-nav")) {
        $(".js-nav-bar").removeClass("open-nav");
      }

      if ($(".js-navbar-toggler").hasClass("open")) {
        $(".js-navbar-toggler ").removeClass("open");
      }
    });
  }

  // close alert
  $(".alert .close").click(function () {
    $(this)
      .parent(".alert")
      .remove();
  });

  //accordion
  $(".js-accordion").click(function () {
    $(this).toggleClass("active");
    $(this)
      .next()
      .slideToggle();
    $(this)
      .parent()
      .toggleClass("accordion-open");
  });

  $(".js-mobile-accordion").click(function () {
    if (screen.width < 992) {
      $(this).toggleClass("active");
      $(this)
        .next()
        .slideToggle();
      $(this)
        .parent()
        .toggleClass("accordion-mobile-open");
    }
  });

  $(".js-submit-newsletter").click(function () {
    var errorMessage = $(this).closest(".js-newsletter").find(".js-error")
    var successMessage = $(this).closest(".js-newsletter").find(".js-success")

    errorMessage.hide();
    successMessage.hide();

    var inputVal = $(".js-newsletter-input").val();

    if (!isEmailValidate(inputVal) && !validateMobile(inputVal)) {
      errorMessage.show();
      errorMessage.text("لطفا ایمیل یا شماره موبایل معتبر وارد کنید.");

      return false;
    }

    $.ajax({
      type: "post",
      url: "/cms/newsletter/Add/",
      data: { EmailOrPhoneNumber: inputVal },
      success: function (data) {
        successMessage.show();
        successMessage.text(data.messages[0].message);

        showAlert(data.Messages);
      },
    });
  });

  $(".js-newsletter-close").click(function () {
    $(this).closest(".js-newsletter").fadeOut();
  });

  // get company credit

  if ($(".js-header-company-credit-refresh").length) {
    getCompanyCredit();

    $(".js-header-company-credit-refresh").click(function () {
      getCompanyCredit();
    });

    $(".js-header-company-toggle").click(function () {
      $(".js-header-company").toggleClass("is-open");

      if (
        $(".js-header-company").hasClass("is-open") &&
        window.innerWidth <= 993
      ) {
        $(".js-header-company-inner").offset({
          top: $(".js-header").offset().top + $(".js-header")[0].offsetHeight,
        });
      } else {
        $(".js-header-company-inner").offset({ top: 0 });
      }

      $("html").toggleClass("no-scroll");
    });
  }
});

